import { transaction, observable, action } from 'mobx'
import * as defaultConst from '../constants/default_constants'
import * as linkConst from '../constants/link_constants'
import moment from 'moment'

export default (BaseClass) => class EtlRunnerState extends BaseClass {
  loadEtlRunner () {
    this.runnerRunning = 'Running'
    this.runnerStatus = {
      Running: [
        this.runnerRunning,
        'Pending',
        'Scheduled'
      ],
      Failed: [
        'Failed',
        'Error',
        'Cancelled'
      ],
      Finished: [
        'Finished',
        'Success'
      ],
      Unknown: [
        'Unknown'
      ]
    }
    this.runnerStatusKeys = Object.keys(this.runnerStatus)
    this.cv = observable({
      loading: true,
      runnerHistory: [],
      runnerInterval: null,
      runnerRunning: [],
      runnerSettings: [],
      title: this.__(linkConst.LINK_ETL_RUNNER_TITLE)
    })

    const flowsHistoryList = `query {
      flow_run (
      order_by: {start_time: desc}
      limit: 50
      where: {start_time: {_is_null: false}, flow: {project: {name: {_eq: "BI"}}}}
      ) {
      flow {
      version_group_id
      name
      }
      start_time
      end_time
      state
      }}`

    const etlSubQuery = thisSettings => {
      let tasksItems = []
      let flowsItems = []
      const ctrlItems = {}
      const flowsResult = {
        Failed: null,
        Finished: null,
        Running: null,
        Unknown: null
      }
      const callParameters = JSON.parse(thisSettings.parameters)
      callParameters.data = JSON.stringify({
        query: flowsHistoryList,
        variables: {}
      })
      return this.requester
        .callExternalRes(callParameters)
        .then(result => {
          flowsItems = (result.data && result.data.data && result.data.data.flow_run) || null
        })
        .then(result => {
          const callParameters = JSON.parse(thisSettings.parameters)
          callParameters.data = JSON.stringify({
            query: thisSettings.subquery,
            variables: {}
          })
          return this.requester.callExternalRes(callParameters)
        })
        .catch(this.onRequesterError.bind(this))
        .then(result => {
          tasksItems = (result.data && result.data.data && result.data.data.task) || null
          if (!tasksItems || !flowsItems) {
            return {
              status: this.runnerStatus.Failed[0],
              message: 'No data loaded',
              updated_at: moment().format(),
              finished_at: moment().format()
            }
          }
          tasksItems.map(i => {
            const n = i.name.substring(5)
            if (!ctrlItems[n]) {
              ctrlItems[n] = true
            }
          })
          Object.keys(ctrlItems).map(i => {
            const n = flowsItems.find(j => j.flow.name === i)
            n && n.state && Object.keys(flowsResult).map(j => {
              const r = (this.runnerStatus[j]).includes(n.state)
              if (r) {
                flowsResult[j] = n.state
              }
            })
          })
          // test only: flowsResult.Failed = true
          if (flowsResult.Running) {
            // false = no finish
            return false
          } else if (flowsResult.Failed) {
            return {
              status: this.runnerStatus.Failed[0],
              message: flowsResult.Failed,
              updated_at: moment().format(),
              finished_at: moment().format()
            }
          } else if (flowsResult.Finished) {
            return {
              status: this.runnerStatus.Finished[0],
              message: flowsResult.Finished,
              updated_at: moment().format(),
              finished_at: moment().format()
            }
          } else if (flowsResult.Unknown) {
            return {
              status: this.runnerStatus.Unknown[0],
              message: flowsResult.Unknown,
              updated_at: moment().format(),
              finished_at: moment().format()
            }
          }
        })
    }

    this.etlRunnerStatus = () => this.requester
      .call(`/${linkConst.LINK_ETL_RUNNER}/settings`, 'get')
      .then(result => {
        this.cv.runnerSettings = result.data
      })
      .catch(this.onRequesterError.bind(this))
      .then(result => {
        return this.requester.call(`/${linkConst.LINK_ETL_RUNNER}/history`, 'get')
      })
      .then(result => {
        const thisPage = this.router.currentView.originalPath === '/' + linkConst.LINK_ETL_RUNNER
        let myJobs = null
        this.cv.loading = false
        this.cv.runnerHistory = result.data
        this.cv.runnerRunning = []
        // map history for running jobs
        this.cv.runnerHistory
          .filter(i => i.status && i.status === this.runnerRunning)
          .map(i => {
            const thisSettings = this.cv.runnerSettings.find(j => j.id === i.runner_id)
            const isRunning = thisSettings && thisSettings.subquery
              ? etlSubQuery(thisSettings)
              : new Promise(resolve => {
                // finish job if no another subquery
                i.updated_at = moment().format()
                resolve(true)
              })

            isRunning.then(result => {
              if (result && result === true) {
                i.updated_at = moment().format()
                i.finished_at = moment().format()
                i.status = this.runnerStatus.Finished[0]
              } else {
                i.status = (result && result.status) || i.status
                i.message = (result && result.message) || i.message
                i.updated_at = (result && result.updated_at) || moment().format()
                if (result && result.finished_at) {
                  i.finished_at = result.finished_at
                }
              }
              // save update
              this.requester
                .call(`/${linkConst.LINK_ETL_RUNNER}/history/${i.id}`, 'put', i)
                .catch(this.onRequesterError.bind(this))
              // jobs status
              if ((this.runnerStatus.Running).includes(i.status)) {
                this.cv.runnerRunning.push(i)
                if (i.launched_by && i.launched_by === this.loggedUser.email) {
                  this.runnerNavStatus = this.cv.runnerSettings.find(j => j.id === i.runner_id).title
                  myJobs = true
                }
                if (!this.runnerInterval) {
                  // setInterval
                  this.runnerInterval = setInterval(
                    _ => this.etlRunnerStatus(),
                    (defaultConst.ETL_RUNNER_INTERVAL * 1000 * 60)
                  )
                }
              }
              // finished
              if (!myJobs && this.runnerNavStatus !== null && this.runnerNavStatus !== defaultConst.TITLE_FINISHED) {
                clearInterval(this.runnerInterval)
                this.addMessage(this.__('Job finished'), 'info')
                this.runnerNavStatusSet(thisPage
                  ? null
                  : defaultConst.TITLE_FINISHED)
              }
            })
          })
      })

    this.requester.call(`/${linkConst.LINK_ETL_RUNNER}/settings`, 'get')
      .then(result => {
        this.cv.runnerSettings = result.data || []
      })
      .catch(this.onRequesterError.bind(this))
      .then(_ => {
        return this.etlRunnerStatus()
      })
      .catch(this.onRequesterError.bind(this))
  }

  @action
  etlStart (id) {
    const data = {
      created_at: moment().format(),
      launched_by: this.loggedUser.email,
      message: 'In process',
      runner_id: id,
      status: this.runnerRunning
    }

    this.requester
      .call(`/${linkConst.LINK_ETL_RUNNER}/history`, 'get')
      .then(result => {
        const isRunning = result.data.find(i => i.status && i.status === this.runnerRunning && i.runner_id === id)
        const thisSettings = this.cv.runnerSettings.find(i => i.id === id)
        if (isRunning) {
          this.addMessage(this.__('This job is already running'), 'warning')
          this.cv.runnerHistory = result.data && result.data
            .filter(i => i.status && i.status === this.runnerRunning)
            .map(i => {
              this.cv.runnerRunning.push(i)
              if (i.launched_by && i.launched_by === this.loggedUser.email) {
                this.runnerNavStatus = this.cv.runnerSettings.find(j => j.id === i.runner_id).title
              }
            })
          return true
        } else {
          const callParameters = JSON.parse(thisSettings.parameters)
          callParameters.data = JSON.stringify({
            query: thisSettings.query,
            variables: {}
          })
          // GQL query
          return this.requester.callExternalRes(callParameters)
            .then(response => {
              // setInterval
              this.runnerInterval = setInterval(
                _ => this.etlRunnerStatus(),
                (defaultConst.ETL_RUNNER_INTERVAL * 1000 * 60)
              )
              // message
              this.addMessage(this.__('Job created'), 'success')
              data.message = 'status: ' + response.status + ', statusText: ' + response.statusText
              // save response
              return this.requester
                .call(`/${linkConst.LINK_ETL_RUNNER}/history`, 'post', data)
                .then(result => {
                  if (result.status !== 201) {
                    this.addMessage(this.__('Job error'), 'error')
                    return false
                  }
                  return this.requester
                    .call(`/${linkConst.LINK_ETL_RUNNER}/history`, 'get')
                    .then(result => {
                      this.cv.runnerHistory = result.data
                      this.cv.runnerHistory.filter(i => i.status && i.status === this.runnerRunning)
                        .map(i => {
                          this.cv.runnerRunning.push(i)
                          if (i.launched_by && i.launched_by === this.loggedUser.email) {
                            this.runnerNavStatus = this.cv.runnerSettings.find(j => j.id === i.runner_id).title
                          }
                        })
                    })
                    .catch(this.onRequesterError.bind(this))
                })
                .catch(this.onRequesterError.bind(this))
            })
            .catch(this.onRequesterError.bind(this))
        }
      })
      .catch(this.onRequesterError.bind(this))
  }
}
